@if (dataSource.length > 0) {
  <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
    @for (column of columns; track column.keyColumn) {
      <ng-container matColumnDef="{{ column.keyColumn }}">
        <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
        <td mat-cell *matCellDef="let element">
          @if (column.keyColumn == 'action') {
            <div class="flex justify-center items-center gap-3">
              @if (column.key.add) {
                @if (!loading) {
                  <mat-icon
                    class="btn-icon-add-outline"
                    fontIcon="add_circle"
                    matTooltip="Associar"
                    (click)="addItem(element)"
                  />
                } @else {
                  <mat-spinner [diameter]="24" mode="indeterminate" />
                }
              }
              @if (column.key.remove) {
                @if (!loading) {
                  <mat-icon
                    class="btn-icon-remove-outline"
                    fontIcon="do_not_disturb_on"
                    matTooltip="Desassociar"
                    (click)="removeItem(element)"
                  />
                } @else {
                  <mat-spinner [diameter]="24" mode="indeterminate" />
                }
              }
            </div>
          } @else if (column.keyColumn == 'cpf') {
            {{ element[column.key] | cpf }}
          }@else if (column.keyColumn == 'cnpj') {
            @if(listClient){
              @if(element.razaoSocial == 'PF'){
                {{ element[column.key] | cpf }}
              }@else{
                {{ element[column.key] | cnpj }}
              }
            }@else{
              {{ element[column.key] | cnpj }}
            }
          }@else if(column.keyColumn == 'corporate_name') {
            @if(listClient){
              {{ element[column.key] == 'PF' ? '-' : element[column.key]}}
            }
            @else{
              {{ element[column.key]}}
            }
          } @else if (column.keyColumn == 'phone') {
            {{ element[column.key] | telefone }}
          } @else {
            {{ element[column.key] }}
          }
        </td>
      </ng-container>
    }
    <tr
      mat-header-row
      class="style-header"
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      class="style-row"
      *matRowDef="let row; columns: displayedColumns"
    ></tr>
  </table>
} @else {
  <div>
    <h3 class="text-center">Sem registros.</h3>
  </div>
}

<!--    <ng-container *ngFor="let column of columns;" matColumnDef="{{column.keyColumn}}">-->
<!--      <th mat-header-cell *matHeaderCellDef> {{ column.description }} </th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        @if (column.keyColumn == 'action') {-->
<!--          <button mat-flat-button class="btn-tg w-1/5" >-->
<!--            Editar-->
<!--          </button>-->
<!--        } @else {-->
<!--          {{element[column.key]}}-->
<!--        }-->
<!--      </td>-->
<!--    </ng-container>-->
